import React, { useState, useEffect } from 'react'
import ToggleContent from './ToggleContent';
import { Container } from 'reactstrap';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect"
import { css } from 'emotion';
import { LargeBusiness, moduleMargins } from '../../Constants';


const ToggleButton = (props) => {
    const [toggleOne, setToggleOne] = useState(true)
    const [toggleTwo, setToggleTwo] = useState(false)

    const handleToggleOne = e => {
        e.preventDefault()
        setToggleOne(true)
        setToggleTwo(false)
    }

    const handleToggleTwo = e => {
        e.preventDefault()
        setToggleOne(false)
        setToggleTwo(true)
    }

    const renderContent = (content) => {
        return { __html: content };
    }

    const lbbundlebutton = LargeBusiness.isLBSite ?{button : "lb-bundle-button-toggle", container : "lb"} : {button: "", container: ""}
    const toggleBtn = [props.toggle.EirToggleButton[0],props.toggle.EirToggleButton[1]]
    const toggleState = [toggleOne,toggleTwo]

    const lbCss = (n) =>(
        LargeBusiness.isLBSite ?{
        color:  toggleState[n] ? (toggleBtn[n].toggleSelectedTextColor !=undefined ? toggleBtn[n].toggleSelectedTextColor :'#FFFFFF')
         : (toggleBtn[n].toggleTextColor  !=undefined ? toggleBtn[n].toggleTextColor: '#666666'),
        border: ` solid 1px` ,
       " background-color":toggleState[n] ? toggleBtn[n].toggleBgColor != undefined ?toggleBtn[n].toggleBgColor:'var(--site-primary-theme)' : '#ececec',
        "box-shadow":toggleState[n] ? ( `0px 10px 33px -10px ${toggleBtn[n].toggleBgColor != undefined ? toggleBtn[n].toggleBgColor : `var(--site-primary-theme)`} !important`)
                     : ( `none !important`) ,  
        cursor: toggleState[n] ? 'default' : 'pointer',
        "border-color" : toggleState[n] ? toggleBtn[n].toggleBorderColor != undefined ?` ${toggleBtn[n].toggleBorderColor}` : 'var(--site-primary-theme)' :'#ececec' ,
    } : {
        color:  toggleState[n] ? toggleBtn[n].toggleSelectedTextColor : toggleBtn[n].toggleTextColor,
        border: ` solid 1px ${toggleBtn[n].toggleBorderColor}` ,
       " background-color":toggleState[n] ? toggleBtn[n].toggleBgColor : '#ffffff', 
        cursor: toggleState[n] ? 'default' : 'pointer',
    }
    )  

    return (
        <Container className={`bundle-card-toggle-main ${lbbundlebutton.container}`}>
            <div className={(isMobileOnly ? '' : 'd-flex align-items-center justify-content-center ')}>
                {props.toggle.toggleButtonPrefix != undefined && props.toggle.toggleButtonPrefix.length > 0 &&
                    <div className='d-flex align-items-center justify-content-center  pt-3 mr-3 toggle_button_prefix ' dangerouslySetInnerHTML={renderContent(props.toggle.toggleButtonPrefix)}></div>
                }
                <div className='d-flex align-items-center justify-content-center toggle pt-3 toggle_button '>
                    <div className={css`${lbCss(0)}` + ' toggle-button-one toggle-anchor d-flex align-items-center justify-content-center ' +lbbundlebutton.button} 
                     id='Bill pay toggle on' onClick={handleToggleOne}>

                        <div className={' toggleOneText'} >
                            {props.toggle.EirToggleButton[0].toggleText}
                        </div>
                    </div>
                    <div className={css`${lbCss(1)}` + ' toggle-button-two toggle-anchor d-flex align-items-center justify-content-center ' +lbbundlebutton.button}
                       id='Phone Pay Toggle on' onClick={handleToggleTwo}>
                        <div className=' toggleTwoText' >
                            {props.toggle.EirToggleButton[1].toggleText}
                        </div>
                    </div>
                </div>
            </div>
            {
                toggleOne &&
                <ToggleContent
                    toggle={props.toggle.EirToggleButton[0]} 
                    id={props.id}
                    backgroundColor={props.toggle.backgroundColor}
                    mobileBackgroundColor={props.toggle.mobilebackgroundColor}
                    />}
            {
                toggleTwo &&
                <ToggleContent
                    toggle={props.toggle.EirToggleButton[1]}
                    id={props.id} 
                    backgroundColor={props.toggle.backgroundColor}
                    mobileBackgroundColor={props.toggle.mobilebackgroundColor}
                    />}
        </Container>
    )
}

export default ToggleButton
